import React from 'react';
import {FormattedMessage} from 'react-intl';
import Icon from 'containers/performance/img/speedometer-icon@2x.png';
import {Button} from 'components';

const CreateNewCycle = ({onCheckInCreated}) => {
  return (
    <div className='bg-white rounded box-shadow-1 p3 mb3 center'>
      <div className='clearfix'>
        <div className='col-8 mx-auto'>
          <div className='center'>
            <img width='100px' className='mt3 mb2' src={Icon} role='presentation' />
          </div>
          <div className='h1'>
            <FormattedMessage id="performance.Create your Check-In Cycle"/></div>
          <div className='h3 mt2 max-width-3 px3 mx-auto'>
            <FormattedMessage id="performance.Employee-leader relationships have a large impact on performance yet 1-on-1s are often pushed off. Performance Check-Ins establish a 1-on-1 framework you can monitor for frequency and quality between employees and leaders." />
          </div>
          <div className='mt3 mb4'>
            <Button className='Btn Btn--large' onClick={onCheckInCreated}>
              <FormattedMessage id="performance.Get Started"/>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewCycle;

